export const primaryLeadStages = ["New", "Contacted", "Interested", "Follow-up", "Converted", "Lost"];
export const leadStages = [
  "New",
  "New Lead",
  "Contacted",
  "Qualified",
  "Interested",
  "Product Recommended",
  "Follow-up",
  "Follow-up Required",
  "Negotiation",
  "Order Created",
  "Converted",
  "Won",
  "Lost",
  "Not Interested",
  "On Hold",
  "Inactive",
  "Dropped",
];
export const customerTypes = ["B2B", "B2C"];
export const industryTypes = [
  "Tiles",
  "FMCG",
  "IT Services",
  "FinTech",
  "Supply Chain",
  "Logistics",
  "Electronics",
  "Automobile",
  "Healthcare",
  "Retail",
  "Manufacturing",
  "Construction",
  "Interior Design",
];
export const leadSources = ["Website", "Field visit", "Referral", "Campaign", "Walk-in", "Instagram", "Facebook", "LinkedIn", "X/Twitter", "YouTube"];
export const lifecycleStages = ["Initial", "Initiated Order", "Withdrawing"];
export const callOutcomes = ["Connected", "Not connected", "Follow-up required"];
export const visitOutcomes = ["Met", "Not met", "Interested", "Not interested"];
export const painPoints = ["Price", "Quality", "Delivery", "Service", "Competitor", "Other"];

export const dropdownCategories = [
  { key: "designation", label: "Employee designation", area: "Organization" },
  { key: "customerType", label: "Customer type", area: "Prospects" },
  { key: "industryType", label: "Industry type", area: "Prospects" },
  { key: "leadSource", label: "Lead source", area: "Prospects" },
  { key: "painPoint", label: "Pain point", area: "Prospects" },
  { key: "leadStatus", label: "Lead status", area: "Prospects" },
  { key: "lifecycleStage", label: "Lifecycle stage", area: "Prospects" },
  { key: "callOutcome", label: "Call outcome", area: "Activities" },
  { key: "visitOutcome", label: "Visit outcome", area: "Activities" },
];

export const defaultDropdownValues = {
  designation: ["Sales Executive", "Area Manager", "Customer Support", "Administrator"],
  customerType: customerTypes,
  industryType: industryTypes,
  leadSource: leadSources,
  painPoint: painPoints,
  leadStatus: leadStages,
  lifecycleStage: lifecycleStages,
  callOutcome: callOutcomes,
  visitOutcome: visitOutcomes,
};

export function dropdownValues(dropdownOptions = [], category, fallback = defaultDropdownValues[category] || []) {
  const values = dropdownOptions
    .filter((option) => option.category === category && option.active !== false)
    .sort((left, right) => Number(left.sortOrder || 0) - Number(right.sortOrder || 0) || String(left.label || left.value).localeCompare(String(right.label || right.value)))
    .map((option) => option.value || option.label)
    .filter(Boolean);
  return values.length ? [...new Set(values)] : fallback;
}

export function ensureDropdownValue(options, value) {
  const nextValue = String(value || "").trim();
  if (!nextValue) return options;
  return options.includes(nextValue) ? options : [nextValue, ...options];
}
